import { Component } from '@angular/core'
import { AutoBettingService, ClassicService } from '@rush-shared/services'
import { PlayerService } from '@shared/services'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-bet-header',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, FormsModule],
  templateUrl: './bet-header.component.html',
  styleUrl: './bet-header.component.sass',
})
export class BetHeaderComponent {
  constructor(
    public _playerService: PlayerService,
    public _classicService: ClassicService,
    public _autoBettingService: AutoBettingService,
  ) {}

  faRightFromBracket = faRightFromBracket

  onSeat = false

  get showGameComponent() {
    return this._classicService.showGameComponent || this.onSeat
  }

  get showAutoBettingToggle() {
    return this._autoBettingService.validConfigsCount > 0
  }

  get isThreeElement() {
    return (
      this.showAutoBettingToggle && (this.showGameComponent || !this._playerService.currentSeat)
    )
  }

  back() {
    this._classicService.resetActiveDelear()
    this._playerService.clearCurrentSeat()
  }

  toggleAutoBetting() {
    this._autoBettingService.setEnable(this._autoBettingService.enableAutoBetting)
  }
}
